import { Spacing } from '@persona-id/design-tokens';
import { FC } from 'react';
import Markdown from 'shared/components/Markdown';
import styled from 'styled-components';

import ThemeSerialized from 'lib/interfaces/ThemeSerialized';
import { TableStaticComponent } from 'lib/interfaces/ui-components';
import { fontFamilyCss } from 'verify/lib/utils/font-family';

const TableStaticContainer = styled.span<{ theme: ThemeSerialized }>`
  font-family: ${({ theme: { fontFamilyTitle } }) => fontFamilyCss(fontFamilyTitle)};

  color: ${({ theme }) => theme.colorFont};
  font-size: ${({ theme }) => theme.fontSizeBody};

  line-height: ${({ theme }) => theme.lineHeightBody};
`;

const Table = styled.table<{ theme: ThemeSerialized }>`
  th,
  td {
    padding: ${Spacing[2]};
  }
`;

const Cell = ({ tag = 'td', children }: { tag?: 'th' | 'td'; children: string }) => {
  if (tag === 'td') {
    return (
      <td>
        <Markdown>{children}</Markdown>
      </td>
    );
  } else {
    return (
      <th>
        <Markdown>{children}</Markdown>
      </th>
    );
  }
};

const TableStatic: FC<{ component: TableStaticComponent }> = ({
  component: {
    attributes: { header, rows },
  },
}) => {
  return (
    <TableStaticContainer>
      <Table>
        {header && header.length > 0 && (
          <thead>
            <tr>
              {header.map((cellText) => (
                <Cell tag='th' key={cellText}>
                  {cellText}
                </Cell>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {rows.map((row) => {
            return (
              <tr key={row.join()}>
                {row.map((cellText) => (
                  <Cell key={cellText}>{cellText}</Cell>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </TableStaticContainer>
  );
};

export default TableStatic;
